import {cva} from 'class-variance-authority';

export const calendarDayVariants = cva(
  [
    'flex aspect-square w-full min-w-(--cell-size) flex-col items-center justify-center gap-1 rounded-full p-2',
    'type-body2 font-medium text-secondary-800 leading-none transition-colors',
    'hover:bg-secondary-50 hover:text-secondary-700',
    'group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10',
    'group-data-[focused=true]/day:ring-2 group-data-[focused=true]/day:ring-ring group-data-[focused=true]/day:ring-offset-2',
    'disabled:pointer-events-none disabled:text-neutral-300',
    'data-[selected-single=true]:bg-secondary-700 data-[selected-single=true]:text-on-action data-[selected-single=true]:hover:bg-secondary-600',
    'data-[range-start=true]:rounded-r-none data-[range-start=true]:bg-secondary-700 data-[range-start=true]:text-on-action data-[range-start=true]:hover:bg-secondary-600',
    'data-[range-end=true]:rounded-l-none data-[range-end=true]:bg-secondary-700 data-[range-end=true]:text-on-action data-[range-end=true]:hover:bg-secondary-600',
    // A single-day range is both range-start and range-end at once — the two
    // rules above would each zero out one side, leaving a square. This
    // compound selector has higher specificity than either alone, so it wins.
    'data-[range-start=true]:data-[range-end=true]:rounded-full',
    'data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-secondary-50 data-[range-middle=true]:text-secondary-900',
    '[&>span]:text-xs [&>span]:opacity-70',
  ].join(' ')
);
